(function() {

	$(document).ready(function() {
		$("body").on("click", ".tab-navigation a", function(event) {
			event.preventDefault();
			var $this = $(this);
			var $targetPane = $($this.attr("href"));
			var $tabs = $this.closest(".tabs");
			var $links = $tabs.find(".tab-navigation a");
			var $panes = $tabs.find(".tab-pane");

			if ($this.hasClass("active")) {
				// Do nothing, if selected tab is already active.
				return;
			}

			// Update tabs
			$links.removeClass("active");
			$this.addClass("active");

			// Update panes
			$panes.fadeOut().promise().done(function() {
				$panes.removeClass("active");
				$targetPane.addClass("active");
				$targetPane.fadeIn();
			});

		});
	});


})();